module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec_bg_8-b4063891330e8c0078e9642234b43dec.svg";